import "./OtherIndustriesSuccessCase.module.css";
import Header from "@/reusable_sections/Header";
import Industrysolutionshero from "./sections/Industrysolutionshero";
import Solutions from "./sections/Solutions";
import Benefits from "./sections/Benefits";
import IndustryInquiry from "./sections/IndustryInquiry";
import Footer from "@/reusable_sections/Footer";
export default function OtherIndustriesSuccessCasePage() {
  return <div>
      <Header />
      <Industrysolutionshero />
      <Solutions />
      <Benefits />
      <IndustryInquiry />
      <Footer />
    </div>;
}